import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { RACK_MATERIAL_COLORS } from '@/shared/constants/configurator';
import { calculateDiagonal, calculateDiagonalAngle } from '@/shared/lib/math';
import clsx from 'clsx';
import styles from './side-section-border-chunk.module.css';
import { SideSectionBorderChunkProps } from './side-section-border-chunk.props';

export const SideSectionBorderChunk = ({
	height,
	width,
	className,
	style,
	side,
	...props
}: SideSectionBorderChunkProps) => {
	const {
		state: { material },
	} = useConfigurator();

	const diagonalSize = calculateDiagonal(width * 1.1, height * 0.9);
	const diagonalAngle = calculateDiagonalAngle(width * 1.1, height * 0.9);
	const displayDiagonalAngle = side === 'left' ? diagonalAngle : -diagonalAngle;

	return (
		<div
			className={clsx(styles.wrapper, className)}
			style={{ height, borderColor: RACK_MATERIAL_COLORS[material], ...style }}
			{...props}
		>
			<div
				className={styles.diagonal}
				style={{
					width: diagonalSize,
					minWidth: diagonalSize,
					backgroundColor: RACK_MATERIAL_COLORS[material],
					rotate: `${displayDiagonalAngle}deg`,
				}}
			/>
		</div>
	);
};
